import React from 'react';
import shrinidhiCol from '../../../assets/members/color/shrinidhicol.svg';
import vidhyutCol from '../../../assets/members/color/vidyuthcol.svg';
import tharunCol from '../../../assets/members/color/tharuncol.svg';
import nikithaCol from '../../../assets/members/color/nikithacol.svg';
import midunCol from '../../../assets/members/color/miduncol.svg';
import srivarshiniCol from '../../../assets/members/color/srivarshinicol.svg';
import karstonCol from '../../../assets/members/color/karstoncol.svg';
import kavinCol from '../../../assets/members/color/kavincol.svg';
import vidurCol from '../../../assets/members/color/vidurcol.svg';
import jakrutheeCol from '../../../assets/members/color/jakrutheecol.svg';
import shobikaCol from '../../../assets/members/color/shobikacol.svg';
import mukiyaashCol from '../../../assets/members/color/mukiyaashcol.svg';
import HoverImage from './HoverImage';

const Members = () => {
  return (
    <div id='people' className="px-6 lg:pl-[61px] lg:pr-[77px] pb-8 lg:pb-[64px]">
      {/* Text Section */}
      <div className="font-inter flex flex-col gap-4 items-start xl:w-[56%] lg:w-full">
        <span className="font-bold text-lg lg:text-[22px] text-black">
          Driving Change, Leading the Charge
        </span>
        <span className="font-normal text-sm lg:text-sm text-[#000000CC] text-justify sm:text-left">
          Our leadership team is dedicated to creating opportunities, fostering growth, and inspiring the next generation of tech leaders. These are the changemakers who guide ACM St. Joseph's Chapter toward success and innovation.
        </span>
      </div>

      {/* Image Grid Section */}
      <div className="flex flex-col gap-4 mt-8 lg:gap-0">
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 lg:gap-0">
          <HoverImage src={shrinidhiCol} line1="Shrinidhi C" line2="Chairperson" linkedInUrl= 'https://www.linkedin.com/in/shrinidhi-c-a0a887265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' />
          <HoverImage src={vidhyutCol} line1="Vidhyut Rathi" line2="Vice - Chairperson" linkedInUrl= 'https://www.linkedin1.com/in/vidhyut-rathi-4628a8265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' />
          <HoverImage src={tharunCol} line1="Tharun C" line2="Secretary" linkedInUrl="https://www.linkedin.com/in/tharunc22/" />
          <HoverImage src={nikithaCol} line1="Nikitha C" line2="Joint - Secretary" linkedInUrl= 'https://www.linkedin.com/in/nikhita-sherlin-015222300?u' />
          <HoverImage src={midunCol} line1="Midun Varsan" line2="Treasurer"  linkedInUrl= 'http://www.linkedin.com/in/midunvarsan' />
          <HoverImage src={srivarshiniCol} line1="Srivarshini" line2="Membership - Chair" />
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 lg:gap-0">
          <HoverImage src={karstonCol} line1="Karston" line2="Design Head" />
          <HoverImage src={kavinCol} line1="Kavin Thangamani" line2="Event Head" linkedInUrl= 'https://www.linkedin.com/in/kavin-thangamani-019487283' />
          <HoverImage src={vidurCol} line1="Vidur Varshan" line2="Web Master" linkedInUrl= "https://www.linkedin.com/in/vidur-varshan-332311298" />
          <HoverImage src={jakrutheeCol} line1="Jakruthee D" line2="Social Media Head" linkedInUrl= "https://www.linkedin.com/in/jakruthee-dev-58498a2b8?u" />
          <HoverImage src={shobikaCol} line1="Shobika D" line2="Research Head" />
          <HoverImage src={mukiyaashCol} line1="Mukiyaash S" line2="Project Head" linkedInUrl= 'https://www.linkedin.com/in/mukiyaash-s' />
        </div>
      </div>
    </div>
  );
};

export default Members;
